module.exports = __webpack_public_path__ + "img/liuguang.40be4670.png";